import { useSnapshot } from 'valtio'

import { crudAtom } from '../crud'
import { setAllCrudSelection } from '../write/setAllCrudSelection'

export const useAllCrudSelection = () => {
  return [useSnapshot(crudAtom).selection, setAllCrudSelection] as const
}
